import React from 'react';
import { Typography } from 'src/components/PulseUI';
import { twMerge } from 'tailwind-merge';

interface CrmOptionItemProps {
  option: {
    label: string;
    code: string;
    required?: boolean;
  };
  activeItem: { label?: string } | string | null;
  onClick?: () => void;
}

const CrmOptionItem = ({ option, activeItem, onClick }: CrmOptionItemProps) => {
  const isOptionActive =
    option.label === (typeof activeItem === 'string' ? activeItem : activeItem?.label);

  return (
    <li
      className={twMerge(
        'flex items-center gap-2 px-3 py-2 text-sm cursor-pointer bg-white text-neutral-700',
        'border-l-4 hover:border-l-sky-500',
        isOptionActive ? 'font-semibold border-l-sky-500' : 'font-normal border-l-white'
      )}
      aria-label={option.label}
      onClick={onClick}
    >
      <span>{option.label}</span>
      {option?.required && (
        <Typography variant="caption" className="text-gray-500 font-semibold">
          (required)
        </Typography>
      )}
    </li>
  );
};

export default CrmOptionItem;
